/* fb-pct-badge.js — grid badge policy:
     sold out         -> never modified (always wins)
     discount 30–80%  -> "42% OFF" in brand red (the number does the arithmetic for the shopper)
     NEW IN           -> gold "New In" chip (2026-08-27)
     under 30%        -> the plain "Sale" chip, untouched (a 15% chip shouting a number is noise)
     over 80%         -> silent, assume a pricing error rather than advertise it

   NEW IN is driven by the `new-in` product TAG. Handles reach the browser via
   window.FB_NEWIN, emitted by fb-announce.liquid from the automated collection
   new-in-system (rule: tag = new-in). Tag a product -> chip appears; untag -> it goes.
   No theme edit is ever needed to add or remove a product.
   Gold (#C9A227), never red — red stays reserved for discounts so the two never compete
   on one card. A new-in product with a real >=30% discount keeps the red % badge: the
   number sells harder than the novelty.

   2026-09-16 (WINTER 26): owner rule — never "FLAT". The chip is just "35% OFF": the earlier
   "SALE · 35% OFF" ran 104px across a 170px phone card and sat on the model's face. Red already
   says sale. window.FB_FLAT prefix kept only so the FLAT campaign theme still works if ever published.

   Reads each card's own printed prices — no metafields, no card-product.liquid surgery.
   Thresholds live in MIN_PCT / MAX_PCT below; they are the only things to change.
   Styles are applied INLINE with !important: the theme has higher-specificity !important
   rules on .card__badge .badge, and inline is the only reliable winner.
   NOTE on parsing: the money string is "From Rs.3,550" — the dot in "Rs." must be stripped
   or parseFloat reads 0.355. Leading punctuation is removed before parsing. */
(function () {
  'use strict';

  var RED = '#E81C24';
  var GOLD = '#C9A227';
  var INK = '#1a1a1a';
  var MIN_PCT = 30;   // below this the plain "Sale" chip stays
  var MAX_PCT = 80;   // above this, assume a pricing error and stay silent

  function num(el) {
    if (!el) return 0;
    var t = (el.textContent || '')
      .replace(/[^0-9.,]/g, '')   // drop "From", "Rs", spaces, nbsp
      .replace(/^[.,]+/, '')      // drop the orphaned dot left by "Rs."
      .replace(/,/g, '');         // thousands separators
    var n = parseFloat(t);
    return isFinite(n) ? n : 0;
  }

  function pctFor(card) {
    var sale = card.querySelector('.price__sale');
    if (!sale) return 0;
    // was = the struck-through figure; now = the .price-item--sale figure
    var was = num(sale.querySelector('s .money') || sale.querySelector('s'));
    var box = sale.querySelector('.price-item--sale');
    var now = num((box && box.querySelector('.money')) || box);
    if (!was || !now || now >= was) return 0;
    return Math.round((was - now) * 100 / was);
  }

  function paint(badge, pct) {
    badge.textContent = (window.FB_FLAT ? 'FLAT ' : '') + pct + '% OFF';
    badge.classList.add('fb-pctbadge');
    var s = badge.style;
    s.setProperty('background', RED, 'important');
    s.setProperty('background-color', RED, 'important');
    s.setProperty('background-image', 'none', 'important');
    s.setProperty('color', '#ffffff', 'important');
    s.setProperty('border-color', RED, 'important');
    s.setProperty('font-weight', '600', 'important');
    s.setProperty('opacity', '1', 'important');
  }

  function paintNew(badge) {
    badge.textContent = 'New In';
    badge.classList.add('fb-newbadge');
    var s = badge.style;
    s.setProperty('background', GOLD, 'important');
    s.setProperty('background-color', GOLD, 'important');
    s.setProperty('background-image', 'none', 'important');
    s.setProperty('color', INK, 'important');
    s.setProperty('border-color', GOLD, 'important');
    s.setProperty('font-weight', '600', 'important');
    s.setProperty('letter-spacing', '.1em', 'important');
    s.setProperty('opacity', '1', 'important');
    s.setProperty('display', 'inline-block', 'important');
  }

  // --- New In -------------------------------------------------------------
  // Cards carry no tag data, so match on the product handle inside the card's link.
  function newSet() {
    var out = {}, list = window.FB_NEWIN;
    if (!list || !list.length) return out;
    for (var i = 0; i < list.length; i++) { out[list[i]] = 1; }
    return out;
  }

  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  // A new-in card often has NO badge element at all (in stock, no compare-at price),
  // so build one in the same slot the theme uses.
  function ensureBadge(card) {
    var slot = card.querySelector('.card__badge');
    if (!slot) return null;
    var b = slot.querySelector('.badge');
    if (b) return b;
    b = document.createElement('span');
    b.className = 'badge badge--bottom-left';
    slot.appendChild(b);
    return b;
  }

  function run() {
    var badges = document.querySelectorAll('.card__badge .badge');
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      if (b.dataset.fbPct) continue;
      if (!/^\s*(on\s+)?sale\s*$/i.test(b.textContent || '')) continue;
      var card = b.closest('.card-wrapper') || b.closest('.card') || b.parentElement.parentElement;
      if (!card) continue;
      var pct = pctFor(card);
      if (pct < MIN_PCT || pct > MAX_PCT) continue;   // leave the plain "Sale" chip alone
      b.dataset.fbPct = String(pct);
      paint(b, pct);
    }

    // second pass: gold New In chip wherever sold-out or a red % badge did not win
    var NEW = newSet();
    if (!NEW) return;
    var cards = document.querySelectorAll('.card-wrapper');
    for (var j = 0; j < cards.length; j++) {
      var c = cards[j];
      if (c.dataset.fbNew) continue;
      var h = handleOf(c);
      if (!h || !NEW[h]) continue;
      var ex = c.querySelector('.card__badge .badge');
      if (ex) {
        var txt = (ex.textContent || '').trim();
        if (/sold\s*out/i.test(txt)) { c.dataset.fbNew = 'skip'; continue; }  // sold out wins
        if (ex.dataset.fbPct) { c.dataset.fbNew = 'skip'; continue; }         // real discount wins
      }
      var target = ensureBadge(c);
      if (!target) continue;
      c.dataset.fbNew = '1';
      paintNew(target);
    }
  }

  var t = null;
  function queue() { clearTimeout(t); t = setTimeout(run, 60); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // filters, pagination and quick-add all re-render the grid
  try {
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
  window.addEventListener('pageshow', queue);
})();